export const loadImageAsync = (url: string) =>
  new Promise<string | undefined>((resolve, reject) => {
    const image = new Image();

    image.addEventListener("load", () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = image.width;
      canvas.height = image.height;

      ctx?.drawImage(image, 0, 0);

      const url = canvas.toDataURL();

      resolve(url);
    });

    image.addEventListener("error", () => {
      reject("Не удалось загрузить изображение");
    });

    image.src = url;
  });
